module.exports = __webpack_public_path__ + "src/img/add-green.1fb6a880.svg";